import { useEffect, useState } from 'react';
import { Layout } from '@/components/layout';
import { Card, Button, Icon, Modal, Tooltip } from '@/components/atoms';
import { toast } from '@/components/atoms/Toast';
import { useBackButton } from '@/hooks';
import { useAuthStore } from '@/store';
import { useNavigate } from 'react-router-dom';
import { getCalendarToken, rotateCalendarToken } from '@/api/booking';
import { logger } from '@/utils/logger';
import styles from './pages.module.css';

export function SettingsPage(): JSX.Element {
  useBackButton();
  const logout = useAuthStore((s) => s.logout);
  const navigate = useNavigate();
  const [icsOpen, setIcsOpen] = useState(false);
  const [icsUrl, setIcsUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!icsOpen) return;
    getCalendarToken()
      .then((res) => setIcsUrl(res.url))
      .catch((err) => logger.error('calendar token', err));
  }, [icsOpen]);

  const rotate = async (): Promise<void> => {
    try {
      const res = await rotateCalendarToken();
      setIcsUrl(res.url);
      toast.success('Токен оновлено');
    } catch (err) {
      logger.error('rotate token', err);
      toast.error('Не вдалось оновити');
    }
  };

  return (
    <Layout title="Налаштування">
      <Card>
        <strong>Мова</strong>
        <p className={styles.note}>Українська. Інші мови — пізніше.</p>
      </Card>
      <Card interactive onClick={() => navigate('/me/blocked')}>
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 10 }}>
          <Icon name="blocked" size={20} />
          <span>Заблоковані клієнти</span>
        </span>
      </Card>
      <Card interactive onClick={() => setIcsOpen(true)}>
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 10 }}>
          <Icon name="calendar" size={20} />
          <span>Експорт у календар</span>
          {/* F-160 D4: clarify what the link is for */}
          <Tooltip
            content="Лінк для імпорту в Google/Apple Calendar"
            placement="bottom"
          />
        </span>
      </Card>
      {icsOpen && (
        <Modal open onClose={() => setIcsOpen(false)} title="Експорт у календар">
          <p className={styles.note}>
            Додай це посилання у Google Calendar / Apple Calendar як підписку.
            Бронювання на 90 днів вперед будуть синхронізуватися автоматично.
          </p>
          <input
            type="text"
            readOnly
            value={icsUrl ?? 'Завантаження…'}
            style={{ width: '100%', padding: 8, marginTop: 8 }}
            onFocus={(e) => e.currentTarget.select()}
          />
          <div className={styles.formRow} style={{ marginTop: 12 }}>
            <Button onClick={rotate}>Обновити токен</Button>
            <Button variant="secondary" onClick={() => setIcsOpen(false)}>
              Закрити
            </Button>
          </div>
        </Modal>
      )}
      <Card>
        <strong>Сесія</strong>
        <p className={styles.note}>JWT зберігається локально, скидається при логауті.</p>
        <Button
          variant="destructive"
          style={{ marginTop: 8 }}
          onClick={() => {
            logout();
            navigate('/');
          }}
        >
          Вийти
        </Button>
      </Card>
      <Card>
        <strong>Про додаток</strong>
        <p className={styles.note}>
          Створено за допомогою{' '}
          <a
            href="https://faion.net"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: 'var(--accent, #2481cc)', textDecoration: 'underline' }}
          >
            faion.net
          </a>
        </p>
      </Card>
    </Layout>
  );
}
